<mat-form-field appearance="outline">
    <mat-label>{{label}}</mat-label>
    <input required matInput [formControl]="control">
</mat-form-field>
